import React, { Component } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, LinearProgress, Switch } from '@mui/material';

export default class ApproveFormModal extends Component {

  state = {
    isEmployerCurrent: (this.props.employer || {}).employer_name === (this.props.form.employer || {}).employer_name,
  }

  render() {
    const { status, onCancel, isUpdating, form, employer } = this.props;

    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
      >
        <DialogTitle id="alert-dialog-title">Confirm action</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`You are going mark this form as ${status}, and an automatic email will be sent to the user notifying this status change. Do you want to proceed?`}
          </DialogContentText>
          {status === 'approved' && (form.form == '2' || form.form == '3') && (
            <FormControlLabel control={<Switch disabled={isUpdating}
              checked={this.state.isEmployerCurrent || employer.employer_name === (form.employer || {}).employer_name}
              onChange={(e) => this.setState({ isEmployerCurrent: e.target.checked })}
              value="isEmployerCurrent" />}
              label="Check this if this form was sent for current employer"
            />
          )}
          {isUpdating && <LinearProgress />}
        </DialogContent>
        {!isUpdating && (
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => this.props.onApprove(form.id, status, this.state.isEmployerCurrent)}
              color="primary"
              autoFocus
            >
              Approve
            </Button>
            <Button onClick={onCancel} color="primary">
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}
